// extracted by mini-css-extract-plugin
module.exports = {"rotation":"WishlistModal_rotation__1I4hA"};